import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationMessageLinkDto } from 'src/cer-app/cer-app-notifications/cer-app-notification.service';
import { CerLocaleService } from '@ui/cer-ui-locale.service';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';


@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnDestroy, OnInit {
  private subscriptionManager$: Subscription = new Subscription();

  protected userId: number = null;
  protected hasLogin: boolean = false;

  private userNotificationsAll: NotificationMessageLinkDto[] = null;
  protected userNotifications: NotificationMessageLinkDto[] = null;
  protected hasNotifications: boolean = false;
  protected unreadCount: number = 0;

  constructor(
    private sessionService: CerSessionService,
    private routerService: CerAppRouteService,
    private localeService: CerLocaleService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptionManager$.add(
      this.sessionService.user.user$.subscribe(user => {
        //this.user = user;
        this.userId = user?.id;
        this.hasLogin = this.sessionService.isAuthenticated();
        this.refresh();
      }));

    this.subscriptionManager$.add(
      this.sessionService.user.notifications$.subscribe(msgs => {
        this.userNotificationsAll = msgs;
        this.refresh();
      })
    );
  }

  private refresh(): void {
    if (this.userNotificationsAll && this.userId) {
      this.userNotifications = this.userNotificationsAll.filter(m => m.userId === this.userId);
      this.hasNotifications = this.userNotifications && this.userNotifications.length != 0;
      this.unreadCount = this.userNotifications ? this.userNotifications.filter(m => m.isRead == false).length : 0;
      this.routerService.setIsLoading(false);
      this.cdr.detectChanges();
    }
  }

  public formatDateRelative(d: Date): string {
    return this.localeService.formatDateRelative(d);
  }

}
